import React from 'react'

import Icon from './Icon'

export default ({ className, onClick, to }) => (
  <button type="button" onClick={onClick} className={`button button--text button--icon ${className}`}>
    <Icon className="icon" icon={to} />
  </button>
)


// WEBPACK FOOTER //
// ./src/components/Global/SliderArrow.js